export default "__VITE_ASSET__Dpyjueow__"